import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ArrowRightSquare({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ArrowRightSquare.Outline {...props} />
  ) : (
    <ArrowRightSquare.Solid {...props} />
  );
}

ArrowRightSquare.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M7.16406 12C7.16406 11.5858 7.49985 11.25 7.91406 11.25H14.2701L11.7931 8.78351C11.4995 8.49124 11.4985 8.01636 11.7908 7.72285C12.0831 7.42933 12.5579 7.42832 12.8515 7.72059L16.6155 11.4686C16.6603 11.5133 16.6989 11.563 16.7307 11.6165C16.7976 11.7287 16.8361 11.8599 16.8361 12C16.8361 12.1304 16.8028 12.253 16.7443 12.3598C16.7101 12.4224 16.6669 12.4803 16.6155 12.5315L12.8515 16.2795C12.5579 16.5718 12.0831 16.5708 11.7908 16.2772C11.4985 15.9837 11.4995 15.5089 11.7931 15.2166L14.2702 12.75H7.91406C7.49985 12.75 7.16406 12.4142 7.16406 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68678 20.4771C2.6053 19.4701 2 18.0343 2 16.334V7.665C2 5.9647 2.60531 4.52906 3.68686 3.52228C4.76234 2.52115 6.24771 2 7.916 2H16.084C17.7533 2 19.2386 2.52427 20.3135 3.52641C21.3943 4.53397 22 5.96915 22 7.665V16.334C22 18.0343 21.3947 19.4701 20.3132 20.4771C19.2378 21.4785 17.7524 22 16.084 22H7.916C6.2476 22 4.76222 21.4785 3.68678 20.4771ZM4.70897 19.3794C5.45978 20.0785 6.5574 20.5 7.916 20.5H16.084C17.4426 20.5 18.5402 20.0785 19.291 19.3794C20.0358 18.6859 20.5 17.6637 20.5 16.334V7.665C20.5 6.34085 20.0362 5.31853 19.2907 4.62359C18.5394 3.92323 17.4417 3.5 16.084 3.5H7.916C6.55729 3.5 5.45966 3.92135 4.70889 4.62022C3.96419 5.31344 3.5 6.3353 3.5 7.665V16.334C3.5 17.6637 3.9642 18.6859 4.70897 19.3794Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ArrowRightSquare.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          className="icon-secondary"
          d="M8.8203 22.6301H16.9883C20.5273 22.6301 22.9043 20.3541 22.9043 16.9651V8.2951C22.9043 4.90611 20.5273 2.6301 16.9883 2.6301H8.8203C5.2823 2.6301 2.9043 4.9071 2.9043 8.2961L2.9043 16.9651C2.9043 20.3541 5.2823 22.6301 8.8203 22.6301Z"
        />
        <path
          className="icon-primary"
          d="M13.7598 16.9094L17.5248 13.1614C17.8078 12.8794 17.8078 12.3804 17.5248 12.0974L13.7598 8.3494C13.4658 8.0574 12.9908 8.0584 12.6988 8.3524C12.4068 8.6464 12.4068 9.1204 12.7008 9.4134L15.1778 11.8804H8.82275C8.40775 11.8804 8.07275 12.2164 8.07275 12.6304C8.07275 13.0444 8.40775 13.3804 8.82275 13.3804H15.1778L12.7008 15.8464C12.5538 15.9934 12.4808 16.1854 12.4808 16.3784C12.4808 16.5694 12.5538 16.7614 12.6988 16.9074C12.9908 17.2004 13.4658 17.2014 13.7598 16.9094Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
